import { createApplicationFormSelector } from './createApplicationFormSelector';

export const selectFullName = (state) => {
    const name = createApplicationFormSelector(state, 'name') || '';
    const middleName = createApplicationFormSelector(state, 'middle_name') || '';
    const surname = createApplicationFormSelector(state, 'surname') || '';
    return `${surname.value || ''} ${name.value || ''} ${middleName.value || ''}`;
};
